<template>
  <div class="sa-ft-main-container">
    <main class="sa-ft-patient-card">
      <header class="sa-ft-patient-header">
        <div class="sa-ft-user-profile">
          <div class="sa-ft-user-avatar">
            {{ jsonData.accettazione.accettazioneAnagrafica.nome.charAt(0) }}{{
              jsonData.accettazione.accettazioneAnagrafica.cognome.charAt(0) }}
          </div>
          <div class="sa-ft-user-name-wrapper">
            <h1 class="sa-ft-name">
              {{ jsonData.accettazione.accettazioneAnagrafica.cognome }} {{
                jsonData.accettazione.accettazioneAnagrafica.nome }}
            </h1>
            <div class="sa-ft-patient-meta-grid">
              <span class="sa-ft-meta-tag-blue"><strong style="font-weight: bold; color:black">CF: </strong>
                <span style="font-weight: bold;">{{ jsonData.accettazione.accettazioneAnagrafica.identificativo
                }}</span></span>
              <span class="sa-ft-meta-tag-blue"><strong style="font-weight: bold; color:black">Sesso: </strong>
                <span style="font-weight: bold;">{{
                  jsonData.accettazione.accettazioneAnagrafica.sesso
                }}</span></span>
              <span class="sa-ft-meta-tag-blue"><strong style="font-weight: bold; color:black">Stato: </strong>
                <span style="font-weight: bold;">{{ jsonData.accettazione.statoAttuale }}</span></span>
            </div>
          </div>
        </div>
      </header>

      <div class="sa-ft-info-grid">
        <div class="sa-ft-info-card sa-ft-info-green">
          <small class="sa-ft-info-label">Prossimo Checkup</small>
          <div class="sa-ft-info-value">Tra 5 giorni</div>
        </div>
        <div class="sa-ft-info-card sa-ft-info-blue">
          <small class="sa-ft-info-label">Impegnative Attive</small>
          <div class="sa-ft-info-value">0 Documenti</div>
        </div>
        <div class="sa-ft-info-card sa-ft-info-orange">
          <small class="sa-ft-info-label">Posizione Attuale</small>
          <div class="sa-ft-info-value">{{ jsonData.accettazione.statoAttuale }}</div>
        </div>
      </div>
      <div class="sa-ft-nav-tabs">
        <button v-for="tab in tabs" :key="tab" class="sa-ft-tab" :class="{ 'sa-ft-tab-active': currentTab === tab }"
          @click="setTab(tab)">
          {{ tab }}
        </button>
      </div>
      <div class="sa-ft-view-container">
        <transition name="sa-ft-fade-slide" mode="out-in">
          <div class="sa-ft-tab-wrapper" :key="currentTab">

            <template v-if="currentTab === 'IMPEGNATIVE'">
              <div class="sa-ft-section-header">
                <h2 class="sa-ft-section-title">Gestione Impegnative</h2>
                <b-button v-b-tooltip.hover size="sm"
                  variant="outline-success outline-primary-noborder sa-margin-right float-sm-right"
                  title="Aggiungi Impegnativa" @click="onClickAggiungiImpegnativa"
                  class="rounded-circle sa-ft-floating-btn success">
                  <b-icon icon="plus"></b-icon>
                </b-button>
                <!-- <button class="sa-ft-add-btn">+ Nuova Ricetta</button> -->
              </div>
              <div style="height: 100%;">
                <AccettazioneSsnImpegnativaComponent1 ref="cmpAccettazioneSsnImpegnativaComponent" />
              </div>
            </template>
            <template v-if="currentTab === 'ANAGRAFICA'">
              <div class="sa-ft-section-header">
                <h2 class="sa-ft-section-title">Dettaglio Anagrafico</h2>
                <b-button v-b-tooltip.hover size="sm" variant="outline-primary" title="Modifica Anagrafica"
                  @click="onClickModificaAnagrafica(item, index, $event.target)"
                  class="rounded-circle sa-ft-floating-btn primary">
                  <b-icon icon="pencil"></b-icon>
                </b-button>
              </div>
              <AccettazioneSsnAnagraficaComponentN :initJsonData="jsonData" ref="cmpAccettazioneSsnAnagraficaComponentN"
                :isEdit="true" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
            </template>
            <template v-if="currentTab === 'STORICO'">
              <div class="sa-ft-section-header">
                <h2 class="sa-ft-section-title">Storico Paziente</h2>
              </div>
              <AccettazioneSsnImpegnativeStoricoComponent ref="cmpAccettazioneSsnImpegnativeStoricoComponent" />
            </template>

          </div>
        </transition>
      </div>
    </main>

    <aside class="sa-ft-timeline-sidebar">
      <div class="sa-ft-sidebar-header">
        <h3>APPUNTAMENTI</h3>
        <span class="sa-ft-badge-count">{{ appuntamentiProssimi.length }} totali</span>
      </div>
      <TimelineComponent :items="appuntamentiProssimi" :maxHeight="650" />
    </aside>

  </div>
</template>

<script>
import UtilityMixin from '../../../utility/UtilityMixin';
import TimelineComponent from "../../../../template/components/utility/TimelineComponent.vue"
import AccettazioneSsnAnagraficaComponentN from "../components/AccettazioneSsnAnagraficaComponentN.vue"
import AccettazioneSsnImpegnativaComponent1 from "./AccettazioneSsnImpegnativaComponentN.vue"
import AccettazioneSsnImpegnativeStoricoComponent from "./AccettazioneSsnImpegnativeStoricoComponent.vue"
import { ContextMixin } from '../../../utility/ContextMixin';
export default {
  mixins: [UtilityMixin, ContextMixin],
  components: {
    TimelineComponent,
    AccettazioneSsnAnagraficaComponentN,
    AccettazioneSsnImpegnativaComponent1,
    AccettazioneSsnImpegnativeStoricoComponent
  },
  data() {
    return {
      currentTab: 'IMPEGNATIVE',
      tabs: ['IMPEGNATIVE', 'ANAGRAFICA', 'STORICO'],
      isEdit: false,
      appuntamentiProssimi: [
        { data: '25/03/2026 09:00', prestazione: 'Visita Cardiologica', medico: 'Dr. Bianchi' },
        { data: '10/04/2026 11:30', prestazione: 'Analisi del Sangue', medico: 'Laboratorio' }
      ],
      idAccettazione: "-1",
      jsonData: {
        accettazione: {
          statoAttuale: 'In Attesa',
          accettazioneAnagrafica: {
            nome: 'Mario',
            cognome: 'Rossi',
            identificativo: 'RSSMRA80A01H501W',
            sesso: 'M'
          }
        }
      }
    }
  },
  methods: {
    init(jsonData) {
      this.jsonData = jsonData;
    },
    setTab(tabName) {
      this.currentTab = tabName;
    },
    onChangeAccettazioneAnagraficaJSON() { /* logic */ },
    onBeforeLoadData() { /* logic */ },
    onAfterLoadData() { /* logic */ },
    onClickAggiungiImpegnativa() {
      this.$refs.cmpAccettazioneSsnImpegnativaComponent.onClickNuovaRicetta();
    }
  }
}
</script>

<style scoped>
/* --- ROOT & LAYOUT --- */
.sa-ft-main-container {
  display: grid;
  /* La sidebar resta fissa, la card prende il resto MA con un tetto massimo */
  grid-template-columns: minmax(600px, 1fr) 300px;
  gap: 25px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  height: 100vh;
  padding: 20px;
  box-sizing: border-box;
  max-height: 100%;

}

/* --- CARD PRINCIPALE --- */
.sa-ft-patient-card {
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 20px;
  padding: 20px;
  max-height: 600px;
  border: 1px solid #e2e8f0;
  box-shadow: 0.2px 2px 4px rgba(34, 47, 62, 0.3);
}

.sa-ft-patient-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 25px;
  position: relative;
}

.sa-ft-user-profile {
  display: flex;
  gap: 18px;
  align-items: center;
}

.sa-ft-user-avatar {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, var(--bg-sidebar), var(--bg-button-primary));
  color: white;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
}

.sa-ft-name {
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

.sa-ft-patient-meta-grid {
  display: flex;
  gap: 10px;
  margin-top: 8px;
  flex-wrap: nowrap;
  overflow: hidden;
}

.sa-ft-meta-tag {

  background: #eaebeec9 !important;
  padding: 7px 5px;
  border-radius: 6px;
  font-size: 11px;
  color: #64748b;
  border: 2px solid #e2e8f0;
}

.sa-ft-meta-tag-blue {
  background: #eaebeec9 !important;
  padding: 7px 5px;
  border-radius: 6px;
  font-size: 11px;
  color: #1a73e8;
  border: 1px solid #64748b;
  border-left: 3px solid #1a73e8;
}

/* --- NAV TABS --- */
.sa-ft-nav-tabs {
  background: #f1f5f9;
  padding: 4px;
  border-radius: 10px;
  display: flex;
  gap: 5px;
  display: flex;
  align-content: center;

}

.sa-ft-tab {
  padding: 4px 10px;
  border-radius: 7px;
  border: none;
  font-weight: 600;
  font-size: 10px;
  cursor: pointer;
  transition: 0.2s;
  background: transparent;
  color: #64748b;
  text-transform: uppercase;
  width: 100%;
}

.sa-ft-tab-active {
  background: white !important;
  color: var(--bg-sidebar) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* --- KPI GRID --- */
.sa-ft-info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-bottom: 20px;
}

.sa-ft-info-card {
  padding: 10px;
  border-radius: 12px;
  border-left-width: 3px !important;
  border: 1px solid transparent;
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
}

.sa-ft-info-green {
  background: #ecfdf5;
  border-left-color: #10b981;
  border-color: #10b981;

}

.sa-ft-info-blue {
  background: #eff6ff;
  border-left-color: #3b82f6;
  border-color: #3b82f6;
}

.sa-ft-info-orange {
  background: #fff7ed;
  border-left-color: #f59e0b;
  border-color: #f59e0b;
}

.sa-ft-info-label {
  font-weight: 700;
  font-size: 10px;
  text-transform: uppercase;
  color: #475569;
  display: block;
}

.sa-ft-info-value {
  font-weight: 700;
  font-size: 15px;
  margin-top: 4px;
  color: #1e293b;
}

/* --- CONTENUTO DINAMICO --- */
.sa-ft-view-container {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
}

.sa-ft-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  position: sticky;
  top: 0;
  padding: 10px 20px;
  z-index: 10;
  background-color: #ffffff;

}

.sa-ft-section-title {
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #334155;
  margin: 0;
}

.sa-ft-add-btn {
  background: #0d9488;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
  cursor: pointer;
}

/* --- SIDEBAR --- */
.sa-ft-timeline-sidebar {
  background: white;
  border-radius: 20px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  max-height: 600px;
  max-width: 300px;
  box-shadow: 0.2px 2px 4px rgba(34, 47, 62, 0.3);
}

.sa-ft-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.sa-ft-sidebar-header h3 {
  font-size: 14px;
  font-weight: 800;
  margin: 0;
  color: #0f172a;
}

.sa-ft-badge-count {
  font-size: 10px;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 10px;
  color: #64748b;
}

/* --- ANIMAZIONI --- */
.sa-ft-fade-slide-enter-active,
.sa-ft-fade-slide-leave-active {
  transition: all 0.3s ease;
}

.sa-ft-fade-slide-enter {
  opacity: 0;
  transform: translateY(10px);
}

.sa-ft-fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 1100px) {
  .sa-ft-main-container {
    grid-template-columns: 1fr;
    /* Una sola colonna, tutto impilato */
    height: auto;
    overflow-y: visible;
  }
}
</style>